import React from 'react';

export interface AchievementItemProps {
    children: string;
}

export const AchievementItem: React.FC<AchievementItemProps> = ({ children }) => {
    // Split the content by " - " to separate the achievement from the institution
    const parts = children.split(' - ');
    const achievement = parts[0];
    const institution = parts[1];

    return (
        <li className='text-vscode-text-muted text-sm flex items-start'>
            <span className='text-vscode-accent mr-2'>•</span>
            <span>
                {achievement}
                {institution && (
                    <>
                        <br />
                        <b>{institution}</b>
                    </>
                )}
            </span>
        </li>
    );
};
